/**
 * Le scene della Casa: le parti che si muovono con lo scorrimento
 * (Anthony, 19 ottobre 2026: "deve essere proprio un'esperienza immersiva",
 * "non mi piace lo spacco netto").
 *
 *   [data-scena="notte"]     la home: Manto, il Daymon e la Casa su un solo
 *                            palco fermo, dieci schermi di corsa
 *   [data-scena="finestra"]  La Casa: il Golfo riempie lo schermo e si
 *                            stringe fino a diventare la finestra
 *   [data-rivela]            una fotografia che si apre dal basso (o da
 *                            sinistra, con il valore "lato")
 *   [data-velocita]          un blocco che scorre un poco più lento o più
 *                            veloce della pagina
 *   [data-parallasse]        una fotografia che scorre dentro la sua cornice
 *   [data-tappe]             le tappe del banco: la cornice ferma, le
 *                            fotografie che salgono con il bordo sfumato
 *   [data-luccica]           la luce che passa una volta sul monile
 *
 * Senza JavaScript la classe scena-viva non arriva: le scene restano ferme
 * e leggibili (il CSS delle sezioni nasconde e muove solo sotto
 * .scena-viva). Con meno movimento richiesto: niente sfocature, niente
 * parallasse e niente luce che passa; le scene seguono comunque lo
 * scorrimento, perché è il lettore a muoverle. Nessun testo qui dentro.
 */
(function () {
  'use strict';

  if (!document.querySelector('[data-scena], [data-rivela], [data-velocita], [data-parallasse], [data-tappe]')) return;

  var radice = document.documentElement;
  radice.classList.add('scena-viva');
  var ridotto = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function limita(v, a, b) { return v < a ? a : v > b ? b : v; }
  function tratto(p, a, b) { return limita((p - a) / (b - a), 0, 1); }
  function morbido(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function esce(t) { return 1 - Math.pow(1 - t, 3); }
  function grande() { return window.innerWidth >= 1024; }
  function cifra(n, d) { return n.toFixed(d); }

  var testa = document.querySelector('.testa');
  function alto() { return testa ? testa.offsetHeight : 0; }

  /* Avanzamento di una sezione con il palco fermo: 0 quando il palco si
     ferma sotto la testata, 1 quando la sezione sta per andarsene. */
  function fermo(el) {
    var r = el.getBoundingClientRect();
    var h = alto();
    var corsa = r.height - (window.innerHeight - h);
    return corsa > 0 ? limita((h - r.top) / corsa, 0, 1) : 0;
  }
  /* Avanzamento nello schermo: 0 quando l'elemento affiora dal basso, 1
     quando esce in alto. */
  function passaggio(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight;
    return limita((vh - r.top) / (vh + r.height), 0, 1);
  }
  function inVista(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > -200 && r.top < window.innerHeight + 200;
  }
  function luccica(el) {
    if (ridotto || !el) return;
    el.classList.remove('luccica');
    void el.offsetWidth;
    el.classList.add('luccica');
  }
  function stile(n, o, t, f) {
    if (!n) return;
    n.style.opacity = cifra(o, 3);
    if (t !== null) n.style.transform = t;
    if (f !== null && !ridotto) n.style.filter = f;
  }
  function maschera(n, m) {
    n.style.webkitMaskImage = m;
    n.style.maskImage = m;
  }

  /* ------------------------------------------------------------------
     La notte, sulla home. u è il tempo della scena, da 0 a 10, uno per
     schermo di scorrimento:
       0    Manto sul nero, il titolo
       0,3  Manto si spegne come una vetrina e diventa nebbia
       0,8  nella nebbia affiora la testa del Daymon sul tappo
       1,2  le tre righe, parola per parola, e la luce si allarga
       4,2  il Daymon si ritira nella nebbia
       4,7  la nebbia si apre sulle nuvole del Golfo
       6,2  il banco, 7,4 il fuoco, 8,6 le pietre, salendo come un sipario
     ------------------------------------------------------------------ */
  function notte(el) {
    var u = fermo(el) * 10;
    function fra(a, b) { return tratto(u, a, b); }

    var manto = el.querySelector('[data-notte-manto]');
    var spegni = morbido(fra(0.3, 1.2));
    stile(manto, 1 - fra(1.0, 1.35), 'scale(' + cifra(1 - 0.06 * spegni, 4) + ')', 'brightness(' + cifra(1 - 0.96 * spegni, 3) + ') blur(' + cifra(spegni * 8, 2) + 'px)');
    var felide = el.querySelector('[data-notte-felide]');
    var tf = esce(fra(0.3, 0.8));
    stile(felide, 1 - tf, 'translate3d(0,' + cifra(-24 * tf, 1) + 'px,0)', 'blur(' + cifra(8 * tf, 2) + 'px)');
    if (felide) felide.style.visibility = tf > 0.99 ? 'hidden' : '';

    var l1 = esce(fra(0.8, 1.8));
    var l2 = morbido(fra(1.8, 2.6));
    var l3 = morbido(fra(2.5, 3.4));
    var ritira = morbido(fra(4.2, 5.0));
    var q = el.querySelector('[data-notte-daymon]');
    if (q) {
      var qi = q.querySelector('img');
      q.style.opacity = cifra(fra(0.8, 1.3) * (1 - fra(4.6, 5.1)), 3);
      var R = 9 + 14 * l1 + 30 * l2 + 140 * l3;
      var S = 10 + 22 * l2 + 40 * l3;
      var dove = grande() ? '46% 37%' : '46% 40%';
      q.style.setProperty('--luce', 'radial-gradient(ellipse ' + cifra(R, 2) + '% ' + cifra(R * 0.78, 2) + '% at ' + dove + ', #000 ' + cifra(S, 1) + '%, transparent 100%)');
      if (qi) {
        var chiaro = (0.35 + 0.25 * l1 + 0.22 * l2 + 0.18 * l3) * (1 - 0.8 * ritira);
        var sfoca = ridotto ? 0 : 6 * (1 - l1) + 3.5 * (1 - l2) + 1.5 * (1 - l3) + 8 * ritira;
        qi.style.filter = 'brightness(' + cifra(chiaro, 3) + ') blur(' + cifra(sfoca, 2) + 'px)';
        qi.style.transform = 'scale(' + cifra(1.12 - 0.05 * l2 - 0.07 * l3 + 0.025 * fra(3.4, 4.2) + 0.05 * ritira, 4) + ')';
      }
    }

    var finestre = [[1.2, 1.8], [1.9, 2.5], [2.6, 3.2]];
    var via = esce(fra(4.1, 4.6));
    var righe = el.querySelectorAll('[data-notte-riga]');
    for (var i = 0; i < righe.length; i++) {
      var parole = righe[i].querySelectorAll('span');
      var f = finestre[Math.min(i, finestre.length - 1)];
      var passo = (f[1] - f[0]) / (parole.length + 1);
      for (var j = 0; j < parole.length; j++) {
        var t = esce(fra(f[0] + j * passo, f[0] + j * passo + passo * 1.8));
        stile(parole[j], t * (1 - via), 'translate3d(0,' + cifra((1 - t) * 0.35 - via * 0.3, 3) + 'em,0)', 'blur(' + cifra((1 - t) * 10 + via * 8, 2) + 'px)');
      }
    }
    var v = esce(fra(3.3, 3.6)) * (1 - via);
    stile(el.querySelector('[data-notte-via]'), v, 'translate3d(0,' + cifra((1 - v) * 10, 2) + 'px,0)', null);
    var parola = el.querySelector('[data-notte-parola]');
    if (parola) parola.style.pointerEvents = v > 0.5 ? 'auto' : 'none';

    var nebbia = el.querySelector('[data-notte-nebbia]');
    if (nebbia) nebbia.style.opacity = cifra(limita(0.6 * fra(0.35, 1.1) - 0.45 * l3 + 0.45 * fra(4.2, 4.9) - 0.6 * fra(5.0, 5.8), 0, 1), 3);

    var casa = el.querySelector('[data-notte-casa]');
    if (!casa) return;
    var entra = morbido(fra(4.7, 5.6));
    casa.style.opacity = cifra(entra, 3);
    var quadri = casa.querySelectorAll('[data-notte-quadro]');
    var segni = el.querySelectorAll('[data-notte-segno]');
    var nomi = el.querySelectorAll('[data-notte-nome]');
    var T = [6.2, 7.4, 8.6];
    var D = 0.8;
    var c = [1];
    var k;
    for (k = 1; k < quadri.length; k++) c[k] = morbido(fra(T[k - 1], T[k - 1] + D));
    var attivo = 0;
    for (k = 0; k < quadri.length; k++) {
      var fig = quadri[k];
      var img = fig.querySelector('img');
      var inizio = k === 0 ? 4.7 : T[k - 1];
      var vita = fra(inizio, k + 1 < quadri.length ? T[k] + D : 10);
      if (k > 0) {
        var A = c[k] * 122 - 22;
        maschera(fig, 'linear-gradient(to top, #000 ' + cifra(A, 2) + '%, transparent ' + cifra(A + 22, 2) + '%)');
        if (c[k] > 0.5) attivo = k;
      }
      var sale = k === 0 ? 0 : 1 - c[k];
      var nebbioso = k === 0 ? 1 - entra : 0;
      if (img) {
        img.style.transform = 'translate3d(0,' + cifra(sale * 14, 2) + '%,0) scale(' + cifra(1 + sale * 0.12 + nebbioso * 0.1 + vita * 0.09, 4) + ')';
        if (k === 0 && !ridotto) img.style.filter = nebbioso > 0.001 ? 'blur(' + cifra(nebbioso * 10, 2) + 'px) brightness(' + cifra(1 - 0.5 * nebbioso, 3) + ')' : 'none';
      }
      fig.style.setProperty('--buio', cifra(k + 1 < quadri.length ? c[k + 1] * 0.55 : 0, 3));
      if (segni[k]) segni[k].style.setProperty('--pieno', cifra(vita, 3));
    }
    for (k = 0; k < nomi.length; k++) nomi[k].classList.toggle('attivo', k === attivo);
    var fascia = el.querySelector('[data-notte-fascia]');
    var ff = esce(fra(5.2, 5.8));
    stile(fascia, ff, 'translate3d(0,' + cifra((1 - ff) * 16, 1) + 'px,0)', null);
    if (fascia) fascia.style.pointerEvents = ff > 0.5 ? 'auto' : 'none';
  }

  /* ------------------------------------------------------------------
     La finestra della Casa: la foto del Golfo riempie il palco e si
     stringe fino alla finestra; il titolo è scritto due volte, nero sul
     muro e crema dentro la finestra, così il colore cambia sul bordo.
     ------------------------------------------------------------------ */
  function finestra(el) {
    var p = fermo(el);
    var w = morbido(tratto(p, 0.04, 0.7));
    var meta = grande() ? [7, 5, 13, 50] : [4, 5, 47, 5];
    var t = meta[0] * w;
    var r = meta[1] * w;
    var b = meta[2] * w;
    var l = meta[3] * w;
    var vetro = el.querySelector('[data-finestra-vetro]');
    if (!vetro) return;
    vetro.style.clipPath = 'inset(' + cifra(t, 3) + '% ' + cifra(r, 3) + '% ' + cifra(b, 3) + '% ' + cifra(l, 3) + '%)';
    var img = vetro.querySelector('img');
    if (img) img.style.transform = 'scale(' + cifra(1 + 0.08 * w, 4) + ')';
    var ombra = el.querySelector('[data-finestra-ombra]');
    if (ombra) ombra.style.opacity = cifra(1 - w, 3);
    var telaio = el.querySelector('[data-finestra-telaio]');
    if (telaio) {
      telaio.style.top = t + '%';
      telaio.style.right = r + '%';
      telaio.style.bottom = b + '%';
      telaio.style.left = l + '%';
      telaio.style.opacity = cifra(tratto(w, 0.7, 1), 3);
    }
    var testo = el.querySelector('[data-finestra-testo]');
    var tt = esce(tratto(p, 0.55, 0.82));
    stile(testo, tt, 'translate3d(0,' + cifra((1 - tt) * 18, 2) + 'px,0)', null);
    var did = el.querySelector('[data-finestra-didascalia]');
    if (did) {
      did.style.left = (l + 0.2) + '%';
      did.style.top = 'calc(' + (100 - b) + '% + 10px)';
      did.style.opacity = cifra(tratto(p, 0.72, 0.88), 3);
    }
  }

  /* ------------------------------------------------------------------
     Le parti che si ripetono.
     ------------------------------------------------------------------ */
  function rivela(el) {
    var pv = passaggio(el);
    var r = ridotto ? 1 : esce(tratto(pv, 0.02, 0.34));
    if (el.getAttribute('data-rivela') === 'lato') el.style.clipPath = 'inset(0 ' + cifra((1 - r) * 100, 3) + '% 0 0)';
    else el.style.clipPath = 'inset(' + cifra((1 - r) * 100, 3) + '% 0 0 0)';
    var img = el.querySelector('img');
    if (img && !el.hasAttribute('data-parallasse')) img.style.transform = 'scale(' + cifra(ridotto ? 1 : 1.16 - 0.16 * r, 4) + ')';
  }
  function muovi(el) {
    if (ridotto) return;
    var v = parseFloat(el.getAttribute('data-velocita') || '0');
    el.style.transform = 'translate3d(0,' + cifra((0.5 - passaggio(el)) * v * 100, 3) + 'vh,0)';
  }
  function parallasse(el) {
    if (ridotto) return;
    var img = el.querySelector('img');
    if (img) img.style.transform = 'translate3d(0,' + cifra((passaggio(el) - 0.5) * -16, 3) + '%,0)';
  }

  var tappaAttiva = -1;
  function tappe(sez) {
    var voci = sez.querySelectorAll('[data-tappa]');
    var foto = sez.querySelectorAll('[data-tappa-foto]');
    var segni = sez.querySelectorAll('[data-tappa-segno]');
    var idx = 0;
    var vh = window.innerHeight;
    var i;
    for (i = 0; i < voci.length; i++) if (voci[i].getBoundingClientRect().top < vh * 0.5) idx = i;
    if (idx === tappaAttiva) return;
    tappaAttiva = idx;
    for (i = 0; i < voci.length; i++) voci[i].classList.toggle('attiva', i === idx);
    var ultima = 0;
    for (i = 0; i < foto.length; i++) {
      var n = parseInt(foto[i].getAttribute('data-tappa-foto'), 10);
      var aperta = n <= idx;
      foto[i].classList.toggle('aperta', aperta);
      if (aperta) ultima = i;
    }
    for (i = 0; i < segni.length; i++) segni[i].style.setProperty('--pieno', i <= idx ? 1 : 0);
    var accesa = foto[ultima];
    if (accesa && accesa.hasAttribute('data-luccica') && parseInt(accesa.getAttribute('data-tappa-foto'), 10) === idx) {
      setTimeout(function () { luccica(accesa); }, 700);
    }
  }

  /* ------------------------------------------------------------------
     Il ciclo: un solo aggiornamento per fotogramma.
     ------------------------------------------------------------------ */
  var inAttesa = false;
  function aggiorna() {
    inAttesa = false;
    var el = document.querySelectorAll('[data-scena]');
    var i;
    for (i = 0; i < el.length; i++) {
      if (!inVista(el[i])) continue;
      var nome = el[i].getAttribute('data-scena');
      if (nome === 'notte') notte(el[i]);
      else if (nome === 'finestra') finestra(el[i]);
    }
    el = document.querySelectorAll('[data-rivela]');
    for (i = 0; i < el.length; i++) if (inVista(el[i])) rivela(el[i]);
    el = document.querySelectorAll('[data-velocita]');
    for (i = 0; i < el.length; i++) if (inVista(el[i])) muovi(el[i]);
    el = document.querySelectorAll('[data-parallasse]');
    for (i = 0; i < el.length; i++) if (inVista(el[i])) parallasse(el[i]);
    var t = document.querySelector('[data-tappe]');
    if (t && grande()) tappe(t);
  }
  function chiedi() {
    if (!inAttesa) {
      inAttesa = true;
      window.requestAnimationFrame(aggiorna);
    }
  }
  window.addEventListener('scroll', chiedi, { passive: true });
  window.addEventListener('resize', function () { tappaAttiva = -1; chiedi(); });

  /* La luce sul monile dell'apertura: una volta all'arrivo, e di nuovo
     quando il puntatore ci passa sopra. */
  var vetrina = document.querySelector('[data-luccica-subito]');
  if (vetrina) {
    setTimeout(function () { luccica(vetrina); }, 1700);
    vetrina.addEventListener('mouseenter', function () { luccica(vetrina); });
  }

  aggiorna();
})();
